// App.js
import React from "react";
import "./App.css";
import HomePage from "./pages/HomePage.jsx";
import PropertyPage from "./pages/PropertyPage.jsx";
import Login from "./components/LogIn/Login.jsx";
import Dashboard from "./components/Dashboard/Dashboard.jsx";
import PrivateRoute from "./PrivateRoute.jsx";
import AddProperty from "./components/Dashboard/AddProperty.jsx";
import EditProperty from "./components/Dashboard/EditProperty.jsx";
import ManagePropertyImages from "./components/Dashboard/ManagePropertyImages.jsx";
import PropertyDetailedPage from "./components/Property/PropertyDetailedPage.jsx";
import ContactPage from "./pages/ContactPage.jsx";

import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/Property" element={<PropertyPage />} />
        <Route path="/Login" element={<Login />} />
        <Route
          path="/properties/:title/:id"
          element={<PropertyDetailedPage />}
        />
        <Route
          path="/Dashboard"
          element={
            <PrivateRoute>
              <Dashboard />
            </PrivateRoute>
          }
        />
        <Route
          path="/Dashboard/AddProperty"
          element={
            <PrivateRoute>
              <AddProperty />
            </PrivateRoute>
          }
        />
        <Route
          path="/Dashboard/EditProperty/:id"
          element={
            <PrivateRoute>
              <EditProperty />
            </PrivateRoute>
          }
        />
        <Route
          path="/Dashboard/ManagePropertyImages/:id"
          element={
            <PrivateRoute>
              <ManagePropertyImages />
            </PrivateRoute>
          }
        />

        <Route path="/" element={<Navigate to="/Home" replace />} />{" "}
        {/* Redirect root to Home */}
        <Route path="/contact-us" element={<ContactPage />} />
      </Routes>
      
    </Router>
  );
}

export default App;
